import { cn } from "@nexus/ui";
import { useTranslation } from "react-i18next";

interface HiddenByFilterNoteProps {
  kind: "videos" | "lines";
  count: number;
  /** Opens the whole order; without it the note is plain text. */
  onReveal?: () => void;
  className?: string;
}

/** Tells the user a Status filter hid rows inside a result they are looking at. */
export function HiddenByFilterNote({
  kind,
  count,
  onReveal,
  className,
}: HiddenByFilterNoteProps) {
  const { t } = useTranslation();
  if (count <= 0) return null;
  const label =
    kind === "videos"
      ? t("marketplace.statusFilter.hiddenVideos", {
          count,
          defaultValue_one: "{{count}} video hidden by filter",
          defaultValue_other: "{{count}} videos hidden by filter",
        })
      : t("marketplace.statusFilter.hiddenLines", {
          count,
          defaultValue_one: "{{count}} line hidden by filter",
          defaultValue_other: "{{count}} lines hidden by filter",
        });
  const classes = cn("px-3 py-1 text-left text-xs text-muted-foreground", className);
  if (!onReveal) {
    return (
      <p data-testid="hidden-by-filter-note" className={classes}>
        {label}
      </p>
    );
  }
  return (
    <button
      type="button"
      data-testid="hidden-by-filter-note"
      className={cn(
        classes,
        "w-full cursor-pointer hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring/50",
      )}
      onClick={(event) => {
        event.stopPropagation();
        onReveal();
      }}
    >
      {label}
      {" · "}
      <span className="underline underline-offset-2">
        {t("marketplace.statusFilter.showAll", "Show all")}
      </span>
    </button>
  );
}
